(function () {
  "use strict";

  var cfg = window.MC_ANALYTICS_CONFIG || {};
  var gtmId = cfg.gtmId;
  // Treat the schema placeholder as "not configured" so we never load a bogus container.
  if (!gtmId || gtmId === "GTM-XXXXXXX") return;

  var loaded = false;
  var analyticsReady = false;
  var marketingReady = false;
  var consentDefaults = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  };

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("consent", "default", consentDefaults);

  // The banner's v3 API is the canonical source of explicit consent. Shopify's
  // analyticsProcessingAllowed() may use implied consent, so it is never a gate.
  var CONSENT_KEY = "mc_cookie_consent_v3";

  function storedConsent() {
    try {
      if (window.mcCookieConsent && typeof window.mcCookieConsent.get === "function") {
        return window.mcCookieConsent.get();
      }
      var value = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
      return value && value.v === 3 ? value : null;
    } catch (e) { return null; }
  }

  function explicitConsentGiven() {
    return storedConsent() !== null;
  }

  function allowed(kind) {
    // If the visitor has never interacted with our banner, nothing is allowed.
    var stored = storedConsent();
    if (!stored) return false;
    // Our banner writes { analytics: true|false, marketing: true|false }.
    if (kind === "analytics") return !!stored.analytics;
    if (kind === "marketing") return !!stored.marketing;
    return false;
  }

  function updateConsent() {
    // Only proceed if the visitor has explicitly made a choice.
    if (!explicitConsentGiven()) return;
    var analytics = allowed("analytics");
    var marketing = allowed("marketing");
    gtag("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
    });
    if (analytics && !analyticsReady) {
      analyticsReady = true;
      window.dataLayer.push({ event: "mc_analytics_ready" });
    } else if (!analytics) {
      analyticsReady = false;
    }
    if (marketing && !marketingReady) {
      marketingReady = true;
      window.dataLayer.push({ event: "mc_marketing_ready" });
    } else if (!marketing) {
      marketingReady = false;
    }
    // Only load GTM once the visitor has granted at least one tracking category.
    if (analytics || marketing) loadGtm();
  }

  function loadGtm() {
    if (loaded) return;
    loaded = true;
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(gtmId);
    document.head.appendChild(s);
  }

  // On page load, check if a returning visitor already gave consent.
  // We read directly from localStorage — never from Shopify's API —
  // because the Shopify API can default to "allowed" before interaction.
  function initFromStorage() {
    if (explicitConsentGiven()) updateConsent();
    // First-time visitors: GTM stays blocked until mc:consentchange fires.
  }

  window.MC_GTM = {
    // The canonical ecommerce observation lane is shared. GTM's tag-level
    // consent checks decide whether GA4 (analytics) and/or ads (marketing) may
    // consume it. This keeps marketing-only and analytics-only choices distinct.
    push: function (event) {
      if (!allowed("analytics") && !allowed("marketing")) return;
      window.dataLayer.push(event);
    },
    load: function () {
      if (allowed("analytics") || allowed("marketing")) loadGtm();
    },
    allowed: allowed,
  };

  // Server-side conversions are dispatched only by the authenticated commerce
  // outbox. The browser deliberately has no CAPI credential or direct endpoint.

  // React to consent events from our banner (mc:consentchange) or Shopify's API.
  document.addEventListener("mc:consentchange", updateConsent);
  document.addEventListener("visitorConsentCollected", updateConsent);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFromStorage);
  } else {
    initFromStorage();
  }
})();
